/*@ngInject*/
const EndorsementActionRepository = function ($q, baseRepository, notificationConstant) {

    angular.extend(this, baseRepository);

    this.getEndorsementSummary = function (endorsementId) {
        const url = '/rest/Endorsement/' + endorsementId;
        return this.get(url);
    };

    this.deleteEndorsement = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId;
        return this.delete(url);
    };

    this.start = function (policyId) {
        var url = '/rest/Policy/' + policyId + '/startEndorsement';
        return this.post(url);
    };

    this.create = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/createEndorsement';
        return this.post(url);
    };

    this.submit = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/submit',
            config = {
                params: {
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.startRating = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/startRating';
        return this.post(url);
    };

    this.refreshQuote = function (endorsementId) {
        const url = '/rest/Endorsement/' + endorsementId + '/refreshQuote';
        return this.post(url);
    };

    this.submitForIssuance = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/submitForIssuance',
            config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.markIssued = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/markAsIssued',
            config = {
                params: {
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.revertToSubmitted = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/revertToSubmitted';
        return this.post(url);
    };

    this.revertToPendingIssuance = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/revertToPendingIssuance';
        return this.post(url);
    };

    this.approve = function (endorsementId, processingInstructions) {
        const url = `/rest/Endorsement/${endorsementId}/approve`;
        return this.post(url, processingInstructions);
    };

    this.decline = function (endorsementId, reason, detail) {
        var url = '/rest/Endorsement/' + endorsementId + '/decline',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.generateRating = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/generateRating';
        return this.post(url);
    };

    this.startPricing = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/startPricing';
        return this.post(url);
    };

    this.modifyPricing = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/modifyPricing';
        return this.post(url);
    };

    this.modifyRating = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/modifyRating';
        return this.post(url);
    };


    this.generateRatingAttachments = function (endorsementId, attachmentsToGenerate) {
        var url = '/rest/Endorsement/' + endorsementId + '/generateRatingAttachments',
            config = {
                params: {
                    attachmentsToGenerate: attachmentsToGenerate
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('endorsementActionRepository', EndorsementActionRepository);
